import { opts } from "../opts.js"
import { connectPagination } from '../../../../dist/vendor/instantsearch.js/es/connectors/index.js';
import { parseTemplate } from "../util/helpers.js";

export const config = {
	...opts.pagination,
}

const renderPagination = (renderOptions, isFirstRender) => {
	const {
	  pages,
	  currentRefinement,
	  nbPages,
	  isFirstPage,
	  isLastPage,
	  refine,
	  createURL,
	} = renderOptions;

	const container = document.querySelector(opts.pagination.container);

	const { cssClasses } = opts.pagination;

	const classes = {
		first: [
			cssClasses.item,
			cssClasses.firstPageItem,
			isFirstPage ? cssClasses.disabledItem : ''
		],
		previous: [
			cssClasses.item,
			cssClasses.previousItem,
			(isFirstPage || !(nbPages - 1)) ? cssClasses.disabledItem : ''
		],
		next: [
			cssClasses.item,
			cssClasses.nextItem,
			(isLastPage || !(nbPages + 1)) ? cssClasses.disabledItem : ''
		],
		last: [
			cssClasses.item,
			cssClasses.lastPageItem,
			isLastPage ? cssClasses.disabledItem : ''
		],
	}
	const svg = {
		next: 'arrow-right',
		last: 'arrow-right',
		first: 'arrow-left',
		previous: 'arrow-left',
	}

	const wrap = (classes, url, value, text) => `
		<li class="${classes.join(' ')}">
			<a href="${url}" data-value="${value}">${text}</a>
		</li>
	`;

	const number = value => {
		const tag = value === currentRefinement ? 'span' : 'a';
		const href = value === currentRefinement ? null : `href="${createURL()}"`;
		const current = currentRefinement === value ? 'current' : '';
		const aria = currentRefinement === value ? 'aria-current="page"' : '';
		return `
			<li class="${cssClasses.number}">
				<${tag} ${href} class="${cssClasses.link} ${current}" ${aria}
					href="${createURL(value)}"
					data-value="${value}"
					>
					<span>${value + 1}</span>
				</${tag}>
			</li>
		`};

	const svgFragment = (svg, text) => parseTemplate(`svg-${svg}`, { text });

	// const first = wrap(classes.first, createURL(0), 0, svgFragment(svg.first, 'First'));
	const previous = wrap(classes.previous, createURL(currentRefinement - 1), currentRefinement - 1, svgFragment(svg.previous, 'Previous'));
	const numbers = pages.map(number).join('');
	const next = wrap(classes.next, createURL(currentRefinement + 1), currentRefinement + 1, svgFragment(svg.next, 'Next'));
	// const last = wrap(classes.last, createURL(nbPages - 1), nbPages - 1, svgFragment(svg.last, 'Last'));

	container.innerHTML = `
		<ul class="${cssClasses.list}">
			${previous}
			<li class="${cssClasses.item} ${cssClasses.numbers}">
				<ul class="${cssClasses.number}s">
					${numbers}
				</ul>
			</li>
			${next}
		</ul>
		`;

	[...container.querySelectorAll('a')].forEach(anchor => {
		anchor.addEventListener('click', event => {
			event.preventDefault();
			refine(event.currentTarget.dataset.value);
		});
	});
};

export const widget = connectPagination(renderPagination);


